import MoreIcon from '@mui/icons-material/More';
import { Button } from "@mui/material";

export const ShowPropertiesButton = (props) => {

    if (("ontouchstart" in document.documentElement)) {
        return (
            <Button aria-label="Show details" color="primary" startIcon={<MoreIcon />}  size="small" variant="outlined" onClick={props.action} sx={{ m: 0.5 }}>
                Show details
            </Button>
        );
    }
    else {
        return (<></>);
    }
}
